import $ from 'jquery';
import { WISHLIST_ID, WishlistItem } from '@gate31/types/wishlist';
import Client from '@gate31/uikit/common/components/client/client';
import { Product } from '@gate31/types';
import { Gate31ApiV2 } from '@gate31/core/src/api/gate31-api';
import { debounce } from 'lodash';
import FavoritesProducts from 'FavoritesProducts';

const WISHLIST_COOKIE = 'wishlist-cookie';

export class Wishlist {
    private static wishlist: Map<number, WishlistItem> = new Map();
    private static _userId: number | undefined;

    static get userId() {
        return this._userId;
    }

    static async sync() {
        const user = await Client.get();

        if (user.status !== 'ok') return;
        this._userId = user.client.id;

        const serializedWishlist = user.client.fields_values.find(f => f.field_id === WISHLIST_ID)?.value;

        if (! serializedWishlist) {
            return this.initWishlist();
        }
        const parsed = this.parseWishlist(serializedWishlist);

        this.wishlist = new Map(parsed.map(item => [ Number(item.id), item ]));

        await this.clear();
        for (const item of parsed) {
            this.updateItem(Number(item.id), item.hidden);

            if (! item.hidden) {
                // eslint-disable-next-line
                await this.add(+item.id)
            }
        }

        FavoritesProducts.update();
    }

    private static initWishlist() {
        const now = Date.now();
        const favorites = FavoritesProducts.getFavoritesProducts().products;

        if (! favorites) return;

        this.wishlist = new Map(
            favorites.map((p): [number, WishlistItem] =>
                [ p.id, {
                    hidden: false,
                    id: p.id.toString(),
                    syncedOn: now } ]
            ));

        this.updateRemote();
    }

    private static add(productId: number): Promise<Product[]> {
        return new Promise((resolve, reject) => {
            window.ajaxAPI.favorites
                .add(productId)
                .done((data: { products: Product[]; status: string }) => {
                    FavoritesProducts.update();
                    resolve(data.products);
                })
                .fail(reject);
        });
    }

    private static clear() {
        return new Promise((resolve, reject) => {
            window.ajaxAPI.favorites
                .clear()
                .done((data: {status: string}) => resolve(data.status))
                .fail(reject);
        });
    }

    static updateItem(productId: number, hidden: boolean) {
        const now = Date.now();

        this.wishlist.set(productId, {
            hidden,
            id: productId.toString(),
            syncedOn: now
        });
    }

    static handleAdd(productId: number) {
        this.updateItem(productId, false);
        this.updateRemote();
    }

    static handleRemove(productId: number) {
        this.updateItem(productId, true);
        this.updateRemote();
    }

    private static updateRemote = debounce(async () => {
        if (! this.userId || ! this.wishlist.size) return;
        await Gate31ApiV2.updateRemoteWishlist(this.userId, Array.from(this.wishlist.values()));
    }, 500)

    private static parseWishlist(wishlistFieldValue: string) {
        const temp = document.createElement('p');

        temp.innerHTML = wishlistFieldValue;
        const result = JSON.parse(temp.textContent ?? '') as WishlistItem[];

        temp.remove();
        return result;
    }
}
